import { render } from "./ContentInfoCard.vue?vue&type=template&id=6c7328fa"
import script from "./ContentInfoCard.vue?vue&type=script&lang=js"
export * from "./ContentInfoCard.vue?vue&type=script&lang=js"

import "./ContentInfoCard.vue?vue&type=style&index=0&id=6c7328fa&lang=scss"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__